<template>
        <div class="zong">
                <!-- 头部导航 -->
                <!-- <div class="nav_top">
                        <div @click="$router.back(-1)"   v-if="noindex" >
                              <i class="el-icon-arrow-left"></i><span>返回</span>
                        </div>
                </div> -->
                
                <!-- 主要内容 -->
                <div class="content">
                                <router-view></router-view>
                                <div class="center copyright">版权所有：石家庄飞天科技开发有限公司</div>
                </div>

               

                <!-- 底部 -->
                <div class="footer">
                        <ul>
                                <li   v-for="(item,index) in list.footer"   :key='item.id'  >
                                        <router-link :to="{name:item.site}"  tag='a'>
                                                <div>
                                                        <img  v-if="list.current === index " :src="item.img"/>
                                                        <img  :src="item.chimg" v-else />
                                                </div>

                                                <p :class="{'active' : list.current === index }">
                                                        {{item.title}}
                                                </p>
                                        </router-link>
                                </li>
                        </ul>
                </div>


                <!-- 返回顶部 -->
                <!-- <el-backtop  :bottom="70" :right="10" :visibility-height='100' style="box-shadow:none;background:transparent">
                               < div class="gotop">
                                          <img src="@/assets/images/gotop.png" />
                                </div>            
                </el-backtop> -->


                <div class="gotop"  @click="returnTop()">
                        <img src="@/assets/images/gotop.png" />
                </div>
        </div>

        
</template>

<script>
  export default({
          data(){
              return{

                list:{
                noindex:false,
                current: '',//导航选中
                footer:[
                        {
                        id: 0,
                        title: "首页",
                        img: require("@/assets/images/sy-c.png"),
                        chimg: require("@/assets/images/sy.png"),
                        site: "meindex"
                        },
                        // {
                        // id: 2,
                        // title: "服务项目",
                        // img: require("@/assets/images/al-c.png"),
                        // chimg: require("@/assets/images/al-h.png"),
                        // site: "mefwxm"
                        // },
                        {
                        id: 1,
                        title: "客户案例",
                        img: require("@/assets/images/mk-c.png"),
                        chimg: require("@/assets/images/mk-h.png"),
                        site: "mecase"
                        },
                        {
                        id: 2,
                        title: "关于我们",
                        img: require("@/assets/images/al-c.png"),
                        chimg: require("@/assets/images/al-h.png"),
                        site: "mezhy"
                        },
                        {
                        id: 3,
                        title: "联系我们",
                        img: require("@/assets/images/wm-c.png"),
                        chimg: require("@/assets/images/wm-h.png"),
                        site: "meus"
                        }
                ]
                }

              }
          },
         
          methods:{
                  
                // 底部导航
                geturl:function(){
                        if(this.$route.name=='meindex'){
                                this.list.current=this.list.footer[0].id;
                          }else if(this.$route.name=='mecase'){
                                this.list.current=this.list.footer[1].id;
                          }else if(this.$route.name=='mezhy'){
                                this.list.current=this.list.footer[2].id;
                          }else if(this.$route.name=='meus'){
                                this.list.current=this.list.footer[3].id;
                          }else{
                                this.list.current='';  
                          }
                        //   console.log(this.$route.path)
                },

                getcolor:function(){
                        if(this.$route.name=='mezhy'||this.$route.name=='meabout'){
                                $('.zong').css('background','#fff')
                                $('.content').css('margin','0 0 70px')  
                        }else if(this.$route.name=='meus'||this.$route.name=='mecase'||this.$route.name=='meitems'){
                                $('.zong').css('background','#f5f5f5')
                                $('.content').css('margin','0 0 70px')  
                        }else{
                                $('.zong').css('background','#f5f5f5')
                                $('.content').css('margin','10px 10px 70px')  
                        }
                },


                returnTop: function() {
                        $("html, body").animate({ scrollTop: 0 }, 800);
                        }

             

          },
          
          created:function(){
                this.geturl()
                this.getcolor()
                //在线咨询
                var _hmt = _hmt || []; (function() { var hm = document.createElement("script"); hm.src = "https://hm.baidu.com/hm.js?217029722c628170238e6a6023570d32"; var s = document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(hm, s); })();
          },
          mounted(){
                this.getcolor();
                             window.document.title='石家庄飞天科技';
                        //      $("#newBridge #nb_icon_wrap .nb-icon-customer").css({"background-size":"70% 70%  !imporant"});
                        //      $("#newBridge #nb_icon_wrap .nb-icon-customer").css({"width":"80px!imporant"})


                        $(".gotop").hide();
                        $(window).bind("scroll resize", function() {
                        if ($(window).scrollTop() <= 200) {
                                $(".gotop").fadeOut(1000);
                        } else {
                                $(".gotop").fadeIn(1000);
                        }
                        });
 
        },
          
          updated:function(){  
                this.geturl()
                this.getcolor()

          },

          watch:{
                  $route(now,old){
                          if(now.path=='/move/index'){
                                  this.noindex=false;

                          }else{
                                this.noindex=true;
                          }
                  },

          }
          
   
  })

</script>


<style lang="less" scoped>

        .gotop{
                text-align: center;
                position: fixed;
                right: 10px;
                bottom: 70px;
                background: #e50012;
                border-radius: 5px;
                overflow: hidden;
                z-index: 9999;
                img{
                        width: 35px;
                }
        }
        .nav_top{
                height:45px;
                overflow: hidden;
                background:brown ;

                div{
                        display: inline-block;
                        float: left;
                        line-height: 45px;
                        padding-left: 10px;
                        font-size: 16px;
                        color: #fff;    
                }

              
        }

        /* .gotop{
                text-align: center;
                color: #e50012;   
                
                img{
                        width: 35px;
                }
        } */

        .content{
                margin: 10px  10px  70px;
                overflow: hidden;
                }
  
     
        .active{
                color: #e50012;
        }
        .zong{  
                min-height: 600px; 
                background: #f5f5f5;
                height: 100%;
                overflow: hidden;
                width: 100%;
                height: 100%;
                max-width: 640px;
                min-width: 300px;
                margin: 0 auto;
        
        }

    
        .footer{
                z-index: 999;
                font-size: 14px;
                background: #fff;
                max-width: 640px;
                min-width: 300px;
                position: fixed;
                bottom:0;
                padding: 7px 0;
                width: 100%;
                border-top: 1px solid #eee;
                ul li {
                        float: left;
                        width: 25%;
                        text-align:center;

                        div{
                                width: 24px;
                                height: 24px;
                                margin: 0 auto 5px;

                                img{
                                        width: 100%;
                                }
                        } 
                        p{

                        }    
                }
        }
</style>


// WEBPACK FOOTER //
// src/components/move/move.vue